<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/dashboard" color="error" icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">Payments</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn class="mx-2 my-0" color="success" depressed small>
      <span>Load All</span>
    </v-btn>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3 pb-2" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-3 pb-3" xs12>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else row wrap justify-center>
        <v-flex class="px-1" xs12 md8>
          <v-text-field
            class="elevation-1"
            label="Search"
            @keyup.enter="search"
            v-model.trim="searchQuery"
            prepend-icon="search"
            :append-icon="searchQuery.length > 0 ? 'close' : ''"
            :append-icon-cb="() => (searchQuery = '', search())"
            solo
          ></v-text-field>
        </v-flex>
        <v-flex class="-hidden-sm-and-down" xs6 md2>
          <v-btn @click.native="search" class="my-0 elevation-0" color="success" block large flat>
            <b>Search</b>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12 md10>
      <v-card class="px-2 pb-2" flat>
        <v-layout row wrap justify-center>
          <v-flex v-if="loading" class="py-5 my-5" xs12>
            <div class="text-xs-center display-3 grey--text text--lighten-1">
              <v-progress-circular color="accent" indeterminate></v-progress-circular>
            </div>
          </v-flex>
          <template v-else>
            <v-flex v-if="listed.length == 0" class="py-5 my-5" xs12>
              <div class="text-xs-center display-3 grey--text text--lighten-1">
                None
              </div>
            </v-flex>
            <template v-else>
              <v-flex class="px-2 pb-4 text-xs-center secondary--text title" xs12>
                <div class="title pb-2">
                  <b>{{listed.length}}{{listed.length == 1 ? ' result' : ' results'}}</b>
                </div>
                <div class="subheading">
                  <b>50 payments per page</b>
                </div>
              </v-flex>
              <v-flex class="px-2 pb-3" xs12 md8>
                <v-layout row>
                  <v-flex class="text-xs-right" xs>
                    <v-btn
                      @click.native="currentPage = currentPage - 1"
                      class="my-0"
                      color="primary"
                      :disabled="currentPage == 0"
                      icon
                      flat
                    ><b><v-icon medium>chevron_left</v-icon></b>
                    </v-btn>
                  </v-flex>
                  <v-flex xs>
                    <v-menu max-height="300px" full-width offset-y>
                      <v-btn slot="activator" color="primary" class="my-0" flat block>
                        <span><b>Page {{currentPage + 1}}</b></span>
                      </v-btn>
                      <v-list>
                        <template v-for="p, i in pages">
                          <v-list-tile v-if="currentPage == i" :key="i">
                            <v-list-tile-title class="grey--text text--lighten-1">
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile v-else :key="i" @click="currentPage = i">
                            <v-list-tile-title>
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-menu>
                  </v-flex>
                  <v-flex xs>
                    <v-btn
                      @click.native="currentPage = currentPage + 1"
                      class="my-0"
                      color="primary"
                      :disabled="(currentPage + 1) == pages.length"
                      icon
                      flat
                    ><b><v-icon medium>chevron_right</v-icon></b>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex class="px-2 pb-4" xs12 md10>
                <v-expansion-panel class="elevation-0">
                  <v-expansion-panel-content class="mb-3" v-for="payment, i in pages[currentPage]" :key="i">
                    <div slot="header">
                      <div class="title secondary--text">
                        <span>${{payment.price}} on {{payment.date}}</span>
                      </div>
                    </div>
                    <v-card>
                      <v-layout row wrap>
                        <v-flex class="pb-1 pl-4" xs12>
                          <div>Student: {{payment.studentName}}</div>
                        </v-flex>
                        <v-flex class="pb-1 pl-4" xs12>
                          <div>Course: {{payment.course}}</div>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
              <v-flex class="px-2 pb-2" xs12 md8>
                <v-layout row>
                  <v-flex class="text-xs-right" xs>
                    <v-btn
                      @click.native="currentPage = currentPage - 1"
                      class="my-0"
                      color="primary"
                      :disabled="currentPage == 0"
                      icon
                      flat
                    ><b><v-icon medium>chevron_left</v-icon></b>
                    </v-btn>
                  </v-flex>
                  <v-flex xs>
                    <v-menu max-height="300px" full-width offset-y top>
                      <v-btn slot="activator" color="primary" class="my-0" flat block>
                        <span><b>Page {{currentPage + 1}}</b></span>
                      </v-btn>
                      <v-list>
                        <template v-for="p, i in pages">
                          <v-list-tile v-if="currentPage == i" :key="i">
                            <v-list-tile-title class="grey--text text--lighten-1">
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile v-else :key="i" @click="currentPage = i">
                            <v-list-tile-title>
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-menu>
                  </v-flex>
                  <v-flex xs>
                    <v-btn
                      @click.native="currentPage = currentPage + 1"
                      class="my-0"
                      color="primary"
                      :disabled="(currentPage + 1) == pages.length"
                      icon
                      flat
                    ><b><v-icon medium>chevron_right</v-icon></b>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </template>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    searchQuery: '',
    entries: [],
    listed: [],
    pages: [],
    currentPage: 0
  }),
  computed: {
    payments () {
      return this.$store.getters.payments
    }
  },
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.entries = []
      let entry = null
      let course = null
      let student = null
      for (let payment of this.payments.reverse()) {
        course = this.$store.getters.courseByKey(payment.courseKey)
        student = this.$store.getters.userById(payment.studentId)
        entry = {
          date: new Date(payment.date).toLocaleString(),
          studentName: student.firstName + ' ' + student.lastName,
          course: course.name,
          price: course.price
        }
        entry.data = entry.studentName + ' ' + course.type + ' ' + course.subject + ' ' + entry.price
        entry.data += ' ' + new Date(payment.date).toDateString()
        entry.data = entry.data.toLowerCase()
        this.entries.push(entry)
      }
      this.search()
    },
    search () {
      this.loading = true
      this.listed = []
      for (let entry of this.entries) {
        if (this.searchQuery.length > 0) {
          if (entry.data.includes(this.searchQuery.toLowerCase())) this.listed.push(entry)
        } else this.listed.push(entry)
      }
      // create pages
      this.pages = []
      let i = 0
      let pageNum = 0
      while (i < this.listed.length) {
        this.pages.push([])
        while (this.pages[pageNum].length < 50) {
          if (i === this.listed.length) break
          this.pages[pageNum].push({...this.listed[i]})
          i++
        }
        pageNum++
      }
      this.currentPage = 0
      this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payments/PaymentsList.vue